<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="1200" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                Changelogs
            </h3>
        </template>

        <template #default>
            <div v-if="items.length == 0" class="text-center">
                {{$t('global.menu.backoffice.noChangelogs')}}
            </div>
            <v-table density="compact" v-else>
                <thead>
                    <tr>
                        <th class="text-left">
                            {{ $t('global.menu.backoffice.date') }}
                        </th>
                        <th class="text-left">
                            {{ $t('global.menu.backoffice.action') }}
                        </th>
                        <th class="text-left">
                            {{ $t('global.form.username') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items" :key="item.name" >
                        <td>{{ $formatDate(item.date) }}</td>
                        <td>{{ item.action }}</td>
                        <td>{{ item.name }}</td>
                    </tr>
                </tbody>
            </v-table>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large"
                    color="primary" @click="closeSheet">Ok</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "ShopChangelogDialog",
    data() {
        return {
        }
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';


const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ translations: {} }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const props = defineProps({
    save: Function, // Define prop as a function
    items: Array
});

const status = computed(() => props.items.status)
const features = computed(() => props.items.features)





const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = {
        translations: { DE: { value: '' }, EN: { value: '' } },
    };
};
onMounted(() => {

});
</script>

<style>
</style>

<style scoped>
</style>
